import React, { useState, useEffect } from 'react';
import ProductCard from '../components/product/ProductCard';
import api from '../services/api';
import LoadingSpinner from '../components/common/LoadingSpinner';

const ShopAllPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const res = await api.get('/products');
        setProducts(Array.isArray(res) ? res : (res.products || []));
      } catch (err) {
        console.error('Failed to fetch products', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllProducts();
  }, []);

  if (loading) return <LoadingSpinner fullScreen text="Loading products..." />;

  return (
    <div className="bg-white min-h-screen py-10 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <h1 className="text-3xl font-light text-center mb-10 tracking-wide">SHOP ALL</h1>
        {products.length === 0 ? (
          <p className="text-center text-gray-500">No products found.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map(product => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopAllPage;